// src/utils/sendEmail.js

const API = 'https://effectivestaff.co.uk';

export const ENDPOINTS = {
  CONTACT:     `${API}/api/send-contact`,
  DEMO:        `${API}/api/send-demo`,
  APPOINTMENT: `${API}/api/send-appointment`,
  CAREERS:     `${API}/api/send-careers`,
};

// JSON forms — contact, demo, appointment
export const sendEmail = async (endpoint, data) => {
  const res = await fetch(endpoint, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify(data),
    credentials: 'omit',
  });
  if (!res.ok) throw new Error('Failed to send');
  return res.json();
};

// FormData — careers with CV attachment
export const sendFormData = async (endpoint, formData) => {
  const res = await fetch(endpoint, {
    method: 'POST',
    body:   formData,
    credentials: 'omit',
  });
  
  const data = await res.json();
  
  if (!res.ok) throw new Error(data.error || 'Failed to send');
  
  return data; // ✅ returns { ok: true }
};